<template>
    <div class="country-popup">
        <h3 class="border-bottom pb-2 mb-2">
            {{ country.names[lang] }}
        </h3>
        <div>
            <a :href="'#@' + country.code" class="fw-bold" @click.prevent="filter">
                {{ country.projects.count }} {{ trans('project_s.label') }}
            </a>
        </div>
        <div v-html="trans('popup.note')" class="smaller text-secondary mt-1"></div>
        <div ref="chart" style="width:100%; min-height: 200px"></div>
    </div>
</template>

<style lang="postcss" scoped>

</style>

<script>
import ApexCharts from 'apexcharts'
import { trans, currentLang } from './AppUtils'


export default {

    emits: [
        'filter',
        'open',
        'close'
    ],

    props: {
        taxonomy: {
            type: Object,
            default: () => ({})
        },
        country: {
            type: Object,
            default: () => ({
                id: -99,
                code: 'XXX',
                names: {
                    en: '?',
                    de: '?'
                },
                projects: {
                    count: 0,
                    dist: {}
                }
            })
        }
    },

    data() {
        return {
            lang: currentLang(),
            colors: {
                '115': '#dfc27d',
                '116': '#beaed4',
                '117': '#fdc086',
                '118': '#7fc97f',
                '119': '#386cb0'
            }
        }
    },

    created() {
        // console.debug("MapPopup", this.country)
    },

    mounted() {

        const dist = this.country.projects.dist
        const lang = this.lang
        const fields = this.taxonomy['research-fields']?.children || []
        const categories = fields.map(f => f.title[lang])
        const data = fields.map(f => dist[f.id] || 0)
        const colors = fields.map(f => this.colors[f.id])
        const max = data.reduce( (carry,val) => Math.max(carry,val) )

        const chart = new ApexCharts(this.$refs.chart, {
            chart: {
                type: 'bar',
                height: 200, // 'auto',
                toolbar: {
                    show: false,
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: true,
                    borderRadius: 4,
                }
            },
            series: [
                {
                    name: 'Projekte',
                    data: data
                }
            ],
            colors: colors,
            dataLabels: {
                enabled: true
            },
            xaxis: {
                categories: categories,
                tickAmount: Math.min(max, 6),
                labels: {
                    show: true,
                    formatter: x => x.toFixed(0)
                }
            },
            yaxis: {
                labels: {
                    show: false,
                }
            },
            legend: {
                show: false
            },
            tooltip: {
                x: {
                    show: false,
                },
                y: {
                    formatter: (val, opt) => opt.w.globals.labels[opt.dataPointIndex] + ': ' + val,
                    title: {
                        formatter: () => ''
                    }
                }
            }
        })

        chart.render()
    },

    methods: {
        trans,

        filter() {
            this.$emit("filter", {c: [ this.country.id ]})
        }
    }

}
</script>